import achievement from "../util/achievement.ts";

// M3-3: the standalone achievements page was retired into an in-place trophy
// MobileSheet opened from the league-history hub. The sheet fetches the same
// account-level (idb.meta) achievement roster the page used, ad hoc on open via
// the `getAchievementsSheet` worker RPC (the M3 data pattern), not the page-view
// pipeline. achievement.getAll() already returns every achievement with the
// number of times earned at each difficulty (0/0/0 = still locked), so this RPC
// is a thin pass-through that keeps the account-level data channel unchanged.
//
// The return shape is an anonymous structural type (no exported alias) so the
// RPC codegen (tools/genApiTypes.ts) expands it inline in
// common/types/.gen/workerApi.d.ts rather than emitting an unresolved name.
export const getAchievementsSheet = async () => {
	return {
		achievements: await achievement.getAll(),
	};
};
